/**
 * SkipLink Component
 *
 * Provides keyboard users a way to skip repetitive navigation and jump directly to main content.
 * WCAG 2.4.1 (Level A): Bypass Blocks
 *
 * Usage:
 * - Place before <Header /> in App.tsx
 * - Ensure main content has id="main-content"
 * - Becomes visible on keyboard focus (Tab key)
 */

export const SkipLink = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
    >
      Skip to main content
    </a>
  );
};
